/**
 * §3a Expert Mode toggle — persists a boolean in localStorage. When enabled,
 * the web client announces itself as the "Expert" analytics condition (§24)
 * and the server-side payload may include the full 21-dimensional attribute
 * vector on scenario cards. The backend 21-dim extension is tracked as a
 * v2.3 follow-up; the UI toggle ships now so participants can opt in early
 * and so the flag is wired into analytics pipelines.
 */

const KEY = 'allot.expertMode';

export function isExpertMode(): boolean {
  try {
    return window.localStorage.getItem(KEY) === '1';
  } catch {
    return false;
  }
}

export function setExpertMode(on: boolean): void {
  try {
    if (on) window.localStorage.setItem(KEY, '1');
    else window.localStorage.removeItem(KEY);
  } catch {
    /* ignore quota */
  }
}
